<template>
    <div>
        <div class="badge-nfse text-center">
            <span v-if="ehSimplesNacional">Simples Nacional</span>
            <span v-else>Regime Normal</span>
        </div>
        <b-row>
            <b-col sm="6" v-if="ehSimplesNacional">
                <SelectStatic title="Situação perante Simples Nacional" :markFormDirty="true" :required="true"
                    :initialValue="regimeTributario.codigoOpcaoSimplesNacional" :disabled="disabled"
                    :data="optionsCodigoOpcaoSimplesNacional" v-model="regimeTributario.codigoOpcaoSimplesNacional" />
            </b-col>
            <b-col :sm="!ehSimplesNacional ? '12' : '6'">
                <SelectStatic title="Tipo de Tributação ISS" :markFormDirty="true" :formName="formName" :disabled="disabled" :required="true"
                    :initialValue="regimeTributario.tipoTributacao" :data="optionsTipoTributacao"
                    v-model="regimeTributario.tipoTributacao" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6" v-if="ehSimplesNacional">
                <SelectStatic title="Regime de Apuração Tributária pelo Simples Nacional" :markFormDirty="true" :disabled="disabled"
                    :required="true" :initialValue="regimeTributario.regimeApuracaoTributariaSimplesNacional"
                    :data="optionsRegimeApuracaoTributariaSimplesNacional"
                    v-model="regimeTributario.regimeApuracaoTributariaSimplesNacional" />
            </b-col>
            <b-col :sm="!ehSimplesNacional ? '12' : '6'">
                <SelectStatic title="Regime Especial de Tributação Municipal" :markFormDirty="true" :disabled="disabled" :required="true"
                    :initialValue="regimeTributario.regimeEspecialTributacaoMunicipal"
                    :data="optionsRegimeEspecialTributacaoMunicipal"
                    v-model="regimeTributario.regimeEspecialTributacaoMunicipal" />
            </b-col>
        </b-row>
        <b-row v-if="!ehSimplesNacional">
            <b-col sm="12">
                <SelectStatic title=" Situação Tributária do PIS/COFINS" :markFormDirty="true" :formName="formName" :disabled="disabled"
                    :required="false" :initialValue="regimeTributario.situacaoTributariaPisCofins"
                    :data="optionsSituacaoTributariaPisCofins" v-model="regimeTributario.situacaoTributariaPisCofins" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";
import NfseNacional from './NfseNacional.js';
import OpcoesTributarias from '../shared/OpcoesTributarias.js';

import { mapActions } from "vuex";

export default {
    name: 'RegimeTributario',
    props: ["disabled", "ehSimplesNacional", "value"],
    components: { SelectStatic },
    data() {
        return {
            id: this.$route.params.id,
            loading: false,
            regimeTributario: new NfseNacional().regimeTributario,
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
        };
    },
    created() {
        if (!this.id) this.obterRegimeTributarioEmpresa();
    },
    computed: {
        OpcoesTributarias() {
            return OpcoesTributarias;
        },
        optionsCodigoOpcaoSimplesNacional() {
            return OpcoesTributarias.codigoOpcaoSimplesNacional;
        },
        optionsTipoTributacao() {
            return OpcoesTributarias.tipoTributacao;
        },
        optionsRegimeApuracaoTributariaSimplesNacional() {
            return OpcoesTributarias.regimeApuracaoTributariaSimplesNacional;
        },
        optionsRegimeEspecialTributacaoMunicipal() {
            return OpcoesTributarias.regimeEspecialTributacaoMunicipal;
        },
        optionsSituacaoTributariaPisCofins() {
            return OpcoesTributarias.situacaoTributariaPisCofins;
        },
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };
            this.getApi(params).then((response) => {
                if (response.success) {
                    const data = response.content;
                    if (data) {
                        this.regimeTributario = {
                            codigoOpcaoSimplesNacional:
                                this.optionsCodigoOpcaoSimplesNacional.find(x => x.id == String(data.codigoOpcaoSimplesNacional)) || { content: 'Não Optante', id: '1' },
                            tipoTributacao:
                                this.optionsTipoTributacao.find(x => x.id == String(data.tipoTributacao)) || { content: 'Tributação no Município', id: '1' },
                            regimeApuracaoTributariaSimplesNacional:
                                this.optionsRegimeApuracaoTributariaSimplesNacional.find(x => x.id == String(data.regimeApuracaoTributariaSimplesNacional)) || { content: 'Federais e municipal pelo SN', id: '1' },
                            regimeEspecialTributacaoMunicipal:
                                this.optionsRegimeEspecialTributacaoMunicipal.find(x => x.id == String(data.regimeEspecialTributacaoMunicipal)) || { content: 'Nenhum', id: '0' },
                            situacaoTributariaPisCofins:
                                this.optionsSituacaoTributariaPisCofins.find(x => x.id == String(data.situacaoTributariaPisCofins)) || { content: 'Operação Tributável com Alíquota Básica', id: '1' },
                        };
                    }
                }
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (this.id) this.regimeTributario = value;
            }
        },
        regimeTributario: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    }
};
</script>

<style scoped>
.badge-nfse {
    background-color: #D98621;
    color: white;
    padding: 10;
    border-radius: 20px;
    width: 150px;
    font-size: 12px;
    margin-bottom: 20px;
}
</style>
